import { useEffect } from 'react';
import { reduce } from '@rmc/webcx-web-libs';
import { WebBlocksApiBlockT } from '../lib/REST/types';

function showElement(id = '', selector = '') {
	const scriptId = `${id}-${selector}`;
	document.getElementById(scriptId)?.remove();
}

function showAllElements(id = '', selectors = '') {
	selectors?.split(';')?.forEach((selector) => showElement(id, selector));
}

export function useAntiFlickering(
	blocks: WebBlocksApiBlockT[] | undefined,
	scriptData: { [key: string]: string },
	isError: boolean = false
) {
	useEffect(() => {
		if (!scriptData.selectors || !blocks) return;

		const callbackFn = (acc: string[], block: WebBlocksApiBlockT) => {
			const selectors =
				block.replacements?.map((replacement) => replacement.selector) || [];

			return [...acc, ...selectors];
		};

		const apiSelectors = reduce(blocks, callbackFn, []);

		const htmlSelectors = scriptData.selectors?.split(';');
		const absentSelectors = htmlSelectors?.filter(
			(selector) => !apiSelectors?.find((api) => api === selector)
		);

		absentSelectors.forEach((selector) => showElement(scriptData.id, selector));
	}, [blocks, scriptData.selectors]);

	useEffect(() => {
		if (!isError) return;
		showAllElements(scriptData.id, scriptData.selectors);
	}, [isError]);

	return {
		onBlockLoad: (selector: string) => showElement(scriptData.id, selector),
	};
}
